import { useQuery } from '@tanstack/react-query';
import { NotificationService } from '@/infra/services/notification';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetNotificationStatusParams {
	organization_id: string;
}

const service = NotificationService.getInstance();

export const useGetNotificationStatus = (params: GetNotificationStatusParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_NOTIFICATION_STATUS, params.organization_id],
		queryFn: () => service.getNotificationStatus(params),
		enabled: !!params.organization_id
	});
};
